import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import {
  MdUpload,
  MdLogout,
  MdDownload,
  MdRefresh,
  MdCloudUpload
} from "react-icons/md";
import { trabajadorApi } from "../../../services/api/trabajadorApi";
import { clienteApi } from "../../../services/api/clienteApi";
import * as XLSX from "xlsx";
import "react-toastify/dist/ReactToastify.css";
import "../../../components/css/Dashboard.css";

const CargaMasivaTrabajadores = () => {
  const navigate = useNavigate();
  const currentUser = JSON.parse(localStorage.getItem("user"));
  const selectedProject = JSON.parse(localStorage.getItem("selectedProject"));
  
  // Estados locales para clientes
  const [clientes, setClientes] = useState([]);
  
  const [file, setFile] = useState(null);
  const [fileForRevalidation, setFileForRevalidation] = useState(null); // Guardar archivo para revalidación
  const [isLoading, setIsLoading] = useState(false);
  const [isValidating, setIsValidating] = useState(false);
  const [progress, setProgress] = useState(0);
  const [results, setResults] = useState(null);
  const [fileValidationErrors, setFileValidationErrors] = useState([]);
  const [isFileValid, setIsFileValid] = useState(false);
  const [skipDniValidation, setSkipDniValidation] = useState(false);
  const [skipDuplicateDniValidation, setSkipDuplicateDniValidation] = useState(false);
  const [autoCompleteDniLength, setAutoCompleteDniLength] = useState(false);
  const [additionalData, setAdditionalData] = useState({
    id_cliente: undefined,
  });

  const showToast = (type, message) => {
    if (type === "success") {
      toast.success(message, { position: "bottom-right", autoClose: 3000 });
    } else if (type === "error") {
      toast.error(message, { position: "bottom-right", autoClose: 3000 });
    } else if (type === "info") {
      toast.info(message, { position: "bottom-right", autoClose: 3000 });
    } else if (type === "warning") {
      toast.warning(message, { position: "bottom-right", autoClose: 3000 });
    }
  };

  // Cargar clientes del proyecto
  useEffect(() => {
    const fetchData = async () => {
      if (selectedProject && selectedProject.id) {
        try {
          // Cargar clientes
          console.log("🔍 Cargando clientes para proyecto:", selectedProject.id);
          const clientesResponse = await clienteApi.getByProyectoRest(selectedProject.id);
          console.log("📋 Respuesta clientes:", clientesResponse.data);
          
          // Verificar estructura de clientes
          let clientesData = [];
          if (clientesResponse.data && Array.isArray(clientesResponse.data)) {
            clientesData = clientesResponse.data;
          } else if (clientesResponse.data && clientesResponse.data.data && Array.isArray(clientesResponse.data.data)) {
            clientesData = clientesResponse.data.data;
          }
          
          setClientes(clientesData);
          
        } catch (error) {
          console.error("❌ Error cargando datos del proyecto:", error);
          showToast("error", "Error cargando clientes");
        }
      }
    };
    fetchData();
  }, [selectedProject?.id]);


  const handleFileChange = async (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileExtension = selectedFile.name.split('.').pop().toLowerCase();
      if (!['xlsx', 'xls'].includes(fileExtension)) {
        showToast("error", 'Por favor seleccione un archivo Excel válido (.xlsx o .xls)');
        e.target.value = '';
        return;
      }
      
      // Guardar archivo para revalidación
      setFileForRevalidation(selectedFile);
      
      // Validar archivo en el backend
      setIsValidating(true);
      setFileValidationErrors([]);
      setIsFileValid(false);
      setResults(null);
      
      try {
        const validationResponse = await trabajadorApi.validateBulkUploadFile(
          selectedFile,
          null, // empresa_colaboradora_id es opcional
          additionalData.id_cliente || null,
          skipDniValidation,
          skipDuplicateDniValidation,
          autoCompleteDniLength
        );
        
        if (validationResponse.data && validationResponse.data.success === false) {
          // Hay errores de validación
          const errors = validationResponse.data.errores_detallados || [];
          setFileValidationErrors(errors);
          setIsFileValid(false);
          setFile(null);
          // NO limpiar fileForRevalidation para poder revalidar
          showToast("error", validationResponse.data.message || "El archivo Excel tiene errores de validación");
        } else {
          // Archivo válido
          setFile(selectedFile);
          setFileValidationErrors([]);
          setIsFileValid(true);
          showToast("success", `Archivo "${selectedFile.name}" validado correctamente`);
        }
      } catch (error) {
        console.error('Error al validar archivo:', error);
        const errorMessage = error.response?.data?.message || error.message || "Error al validar el archivo";
        setFileValidationErrors([{
          fila: 1,
          errores: [errorMessage]
        }]);
        setIsFileValid(false);
        setFile(null);
        e.target.value = '';
        showToast("error", errorMessage);
      } finally {
        setIsValidating(false);
      }
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value.trim() === "" ? undefined : parseInt(e.target.value);
    setAdditionalData({ ...additionalData, [e.target.name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validaciones
    if (!file) {
      showToast("error", 'Por favor seleccione un archivo Excel');
      return;
    }

    if (!additionalData.id_cliente) {
      showToast("error", 'Por favor seleccione un cliente');
      return;
    }

    setIsLoading(true);
    setProgress(0);
    setResults(null);

    try {
      console.log("🚀 Enviando archivo al backend:", file.name);
      console.log("🏢 Cliente ID:", additionalData.id_cliente);

      setProgress(25);

      // Enviar archivo directamente al backend
      const response = await trabajadorApi.bulkUpload(
        file,
        null, // empresa_colaboradora_id es opcional ahora
        additionalData.id_cliente,
        skipDniValidation,
        skipDuplicateDniValidation,
        autoCompleteDniLength
      );

      console.log('✅ Respuesta del backend:', response.data);
      
      setProgress(75);

      const resultados = response.data?.resultados || response.data;
      
      if (resultados && resultados.success === false) {
        // Verificar tipo de error
        if (resultados.errores_detallados && resultados.errores_detallados.length > 0) {
          // Errores de validación - usuario puede corregir
          
          setResults({
            total: resultados.total_procesados || 0,
            success: 0,
            existing: 0,
            errors: resultados.total_errores || 0,
            details: resultados.errores_detallados || [],
            nuevosTrabajadores: 0,
            actualizados: 0
          });

          showToast("error", "Errores de validación encontrados. Revise los detalles a continuación y corrija el archivo.");
        } else {
          // Error del sistema - contacto con soporte
          
          setResults({
            total: 0,
            success: 0,
            existing: 0,
            errors: 1,
            details: [],
            nuevosTrabajadores: 0,
            actualizados: 0
          });

          showToast("error", "Error en el sistema. Contacte con soporte técnico.");
        }
      } else if (resultados) {
        // Carga exitosa normal
        setResults({
          total: resultados.total_procesados || 0,
          success: resultados.nuevos_insertados || 0,
          existing: resultados.existentes || 0,
          errors: resultados.errores || 0,
          ignored: resultados.ignorados || 0,
          details: resultados.detalles_errores || [],
          ignoredDetails: resultados.detalles_ignorados || [],
          nuevosTrabajadores: resultados.nuevos_insertados || 0,
          actualizados: resultados.existentes || 0,
          mensajeDetallado: resultados.mensaje_detallado || null
        });

        // Mostrar advertencias si las hay (ej: campos omitidos)
        if (response.data.advertencias && Array.isArray(response.data.advertencias)) {
          response.data.advertencias.forEach(adv => {
            if (adv.tipo === 'campos_omitidos') {
              showToast("warning", adv.mensaje, { autoClose: 8000 });
            }
          });
        }

        // Mostrar mensaje apropiado según los resultados
        if (resultados.total_procesados === 0 && resultados.ignorados > 0) {
          showToast("info", `Todas las ${resultados.ignorados} filas fueron ignoradas (duplicados o ya existen)`);
        } else if (resultados.ignorados > 0) {
          showToast("success", `Carga completada: ${resultados.total_procesados} procesados, ${resultados.ignorados} ignorados`);
        } else {
          showToast("success", "Carga masiva completada exitosamente");
        }
      } else {
        showToast("success", "Carga masiva completada exitosamente");
      }

      setProgress(100);
      
    } catch (error) {
      console.error('❌ Error en carga masiva:', error);

      if (error.response && error.response.data) {
        const errorData = error.response.data;
        
        if (errorData.message) {
          showToast("error", errorData.message);
        } else if (errorData.error) {
          showToast("error", `Error: ${errorData.error}`);
        } else {
          showToast("error", 'Error desconocido en la carga masiva');
        }
      } else {
        showToast("error", 'Error de conexión. Verifica tu conexión a internet.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const downloadTemplate = () => {
    // Crear template con las columnas en el orden exacto esperado por el backend
    const templateData = [
      {
        'ID TRABAJADOR': '12345',
        'DNI': '12345678',
        'APELLIDOS Y NOMBRES': 'EJEMPLO APELLIDOS Y NOMBRES',
        'CONTRATO': 'CTR-001',
        'GÉNERO': 'Masculino',
        'FECHA INGRESO A PROYECTO': '2024-01-15',
        'CATEGORIA CARGO': 'obrero',
        'CARGO STRACON PERU': 'EJEMPLO CARGO',
        'AREA': 'EJEMPLO AREA',
        'REGIMEN': '21x7',
        'TIPO DIRECTO-INDIRECTO': 'Directo',
        'TIPO MANO DE OBRA': 'MOC',
        'CENTRO COSTO': 'CC-001',
        'TELEFONO': '987654321',
        'DEPARTAMENTO': 'EJEMPLO DEPARTAMENTO',
        'ORIGEN': 'Local',
        'LOCALÍA': 'EJEMPLO LOCALIA',
        'ESTADO DEL COLABORADOR': 'Activo',
        'ESTADO IN SITE': 'In Site'
      }
    ];

    const ws = XLSX.utils.json_to_sheet(templateData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Template");
    XLSX.writeFile(wb, "template_trabajadores.xlsx");
    
    showToast("success", "Template descargado exitosamente");
  };

  const downloadIgnoredRows = () => {
    if (!results || !results.ignoredDetails || results.ignoredDetails.length === 0) {
      showToast("warning", "No hay filas ignoradas para descargar");
      return;
    }

    // Crear datos para el Excel
    const excelData = results.ignoredDetails.map((item, index) => ({
      'No.': index + 1,
      'Fila Excel': item.fila,
      'DNI': item.dni,
      'Motivo': item.motivo
    }));

    // Crear workbook y worksheet
    const ws = XLSX.utils.json_to_sheet(excelData);
    
    // Ajustar ancho de columnas
    ws['!cols'] = [
      { wch: 6 },   // No.
      { wch: 12 },  // Fila Excel
      { wch: 15 },  // DNI
      { wch: 50 }   // Motivo
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Filas Ignoradas");
    
    // Generar nombre de archivo con fecha
    const fecha = new Date().toISOString().split('T')[0];
    const nombreArchivo = `filas_ignoradas_${fecha}.xlsx`;
    
    XLSX.writeFile(wb, nombreArchivo);
    
    showToast("success", `Excel descargado: ${results.ignoredDetails.length} filas ignoradas`);
  };

  const resetForm = () => {
    setFile(null);
    setFileForRevalidation(null);
    setResults(null);
    setProgress(0);
    setFileValidationErrors([]);
    setIsFileValid(false);
    setSkipDniValidation(false);
    setSkipDuplicateDniValidation(false);
    setAutoCompleteDniLength(false);
      setAdditionalData({
        id_cliente: undefined,
      });
    const fileInput = document.querySelector('input[type="file"]');
    if (fileInput) {
      fileInput.value = '';
    }
    showToast("info", "Formulario reiniciado");
  };

  return (
    <>
      {/* Digital Harmony Styles para Carga Masiva Trabajadores */}
      <style>
        {`
          /* Fondo y contenedor principal */
          .dh-carga-bg {
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
            min-height: 100vh;
          }
          
          /* Card principal con Digital Harmony */
          .dh-card-main {
            border: none;
            border-radius: 20px;
            box-shadow: 0 15px 35px rgba(0,0,0,0.1);
            background: white;
          }
          
          /* Header del card */
          .dh-card-header {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            border-radius: 20px 20px 0 0;
            padding: 1.5rem 2rem;
            border: none;
          }
          
          .dh-header-title {
            color: white;
            font-weight: 700;
            font-size: 1.5rem;
            margin: 0;
          }
          
          /* Botones con Digital Harmony */
          .btn-dh-primary {
            background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 10px 16px;
            font-weight: 600;
            box-shadow: 0 4px 14px rgba(17, 153, 142, 0.3);
            transition: all 0.3s ease;
          }
          
          .btn-dh-primary:hover {
            background: linear-gradient(135deg, #38ef7d 0%, #2dd4bf 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(17, 153, 142, 0.4);
            color: white;
          }
          
          .btn-dh-warning {
            background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 10px 16px;
            font-weight: 600;
            box-shadow: 0 4px 14px rgba(240, 147, 251, 0.3);
            transition: all 0.3s ease;
          }
          
          .btn-dh-warning:hover {
            background: linear-gradient(135deg, #f5576c 0%, #e91e63 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(240, 147, 251, 0.4);
            color: white;
          }
          
          .btn-dh-info {
            background: linear-gradient(135deg, #00c6ff 0%, #0072ff 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 10px 16px;
            font-weight: 600;
            box-shadow: 0 4px 14px rgba(0, 198, 255, 0.3);
            transition: all 0.3s ease;
          }
          
          .btn-dh-info:hover {
            background: linear-gradient(135deg, #0072ff 0%, #0056cc 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(0, 198, 255, 0.4);
            color: white;
          }
          
          .btn-dh-secondary {
            background: linear-gradient(135deg, #6b7280 0%, #374151 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 10px 16px;
            font-weight: 600;
            box-shadow: 0 4px 14px rgba(107, 114, 128, 0.3);
            transition: all 0.3s ease;
          }
          
          .btn-dh-secondary:hover {
            background: linear-gradient(135deg, #374151 0%, #1f2937 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(107, 114, 128, 0.4);
            color: white;
          }
          
          /* Formulario mejorado */
          .dh-form-container {
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
            border-radius: 15px;
            padding: 2rem;
            margin-bottom: 1.5rem;
          }
          
          .form-label-dh {
            font-weight: 700;
            color: #374151;
            margin-bottom: 0.75rem;
            font-size: 0.95rem;
          }
          
          .form-select-dh, .form-control-dh {
            border: 2px solid #e5e7eb;
            border-radius: 12px;
            padding: 12px 16px;
            font-size: 1rem;
            transition: all 0.3s ease;
            background: white;
            box-shadow: 0 2px 4px rgba(0,0,0,0.02);
          }
          
          .form-select-dh:focus, .form-control-dh:focus {
            border-color: #667eea;
            box-shadow: 0 0 0 0.25rem rgba(102, 126, 234, 0.15);
            background: white;
          }
          
          /* File upload section */
          .dh-upload-section {
            background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
            border: 2px dashed #16a34a;
            border-radius: 15px;
            padding: 2.5rem;
            text-align: center;
            transition: all 0.3s ease;
            margin: 1.5rem 0;
          }
          
          .dh-upload-section:hover {
            border-color: #15803d;
            background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
            transform: translateY(-2px);
          }
          
          .dh-upload-section.has-file {
            border-color: #059669;
            background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
            box-shadow: 0 8px 25px rgba(16, 185, 129, 0.1);
          }
          
          .upload-icon {
            color: #16a34a;
            margin-bottom: 1rem;
          }
          
          .upload-text {
            color: #374151;
            font-size: 1.1rem;
            font-weight: 600;
            margin-bottom: 0.5rem;
          }
          
          .upload-subtext {
            color: #6b7280;
            font-size: 0.9rem;
            margin-bottom: 1.5rem;
          }
          
          .file-selected-display {
            background: linear-gradient(135deg, #059669 0%, #047857 100%);
            color: white;
            padding: 12px 20px;
            border-radius: 12px;
            font-weight: 600;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            margin: 0.5rem;
            font-size: 1rem;
            box-shadow: 0 4px 14px rgba(5, 150, 105, 0.3);
            border: 2px solid #10b981;
            transition: all 0.3s ease;
            min-width: 180px;
            height: 44px;
          }
          
          .file-selected-display:hover {
            background: linear-gradient(135deg, #047857 0%, #065f46 100%);
            transform: translateY(-1px);
            box-shadow: 0 6px 20px rgba(5, 150, 105, 0.4);
          }
          
          .btn-file-uniform {
            padding: 12px 20px !important;
            border-radius: 12px !important;
            font-weight: 600 !important;
            font-size: 1rem !important;
            min-width: 180px !important;
            height: 44px !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            margin: 0.5rem !important;
            transition: all 0.3s ease !important;
            box-shadow: 0 4px 14px rgba(0,0,0,0.2) !important;
          }
          
          /* Alert mejorado */
          .dh-alert-info {
            background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
            border: 2px solid #3b82f6;
            border-radius: 15px;
            padding: 1.5rem;
            color: #1e40af;
            margin: 1.5rem 0;
          }
          
          .dh-alert-warning {
            background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
            border: 2px solid #f59e0b;
            border-radius: 15px;
            padding: 1rem;
            color: #92400e;
            margin: 1rem 0;
          }
          
          /* Botón de envío mejorado */
          .btn-submit-dh {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 14px 24px;
            font-weight: 700;
            font-size: 1.1rem;
            box-shadow: 0 6px 20px rgba(102, 126, 234, 0.3);
            transition: all 0.3s ease;
            width: 100%;
            margin-top: 1.5rem;
          }
          
          .btn-submit-dh:hover:not(:disabled) {
            background: linear-gradient(135deg, #764ba2 0%, #8b5fbf 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
            color: white;
          }
          
          .btn-submit-dh:disabled {
            background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);
            cursor: not-allowed;
            transform: none;
            box-shadow: none;
          }
          
          /* Progress section */
          .dh-progress-section {
            background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
            border: 2px solid #16a34a;
            border-radius: 15px;
            padding: 2rem;
            margin-top: 2rem;
          }
          
          .progress-dh {
            height: 12px;
            border-radius: 12px;
            background: linear-gradient(135deg, #e5e7eb 0%, #d1d5db 100%);
            overflow: hidden;
            margin: 1rem 0;
          }
          
          .progress-bar-dh {
            background: linear-gradient(135deg, #16a34a 0%, #15803d 100%);
            border-radius: 12px;
            transition: width 0.5s ease;
          }
          
          /* Results section */
          .dh-results-card {
            background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
            border: 2px solid #16a34a;
            border-radius: 20px;
            margin-top: 2rem;
            overflow: hidden;
            box-shadow: 0 10px 25px rgba(16, 185, 129, 0.1);
          }
          
          .dh-results-header {
            background: linear-gradient(135deg, #16a34a 0%, #15803d 100%);
            color: white;
            padding: 1.5rem 2rem;
            border-radius: 20px 20px 0 0;
          }
          
          .dh-results-body {
            padding: 2rem;
          }
          
          .dh-stat-card {
            background: white;
            border-radius: 15px;
            padding: 1.5rem;
            text-align: center;
            box-shadow: 0 4px 15px rgba(0,0,0,0.05);
            transition: all 0.3s ease;
            border: 2px solid transparent;
          }
          
          .dh-stat-card:hover {
            transform: translateY(-3px);
            box-shadow: 0 8px 25px rgba(0,0,0,0.1);
            border-color: #667eea;
          }
          
          .stat-number {
            font-size: 2.5rem;
            font-weight: 800;
            margin-bottom: 0.5rem;
          }
          
          .stat-label {
            font-size: 0.9rem;
            font-weight: 600;
            color: #6b7280;
            text-transform: uppercase;
            letter-spacing: 0.05em;
          }
          
          /* Error table */
          .dh-error-table {
            background: white;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 4px 15px rgba(0,0,0,0.05);
          }

          .dh-error-table thead {
            background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
          }

          .dh-error-table thead th {
            color: white;
            font-weight: 700;
            padding: 1rem;
            border: none;
            font-size: 0.95rem;
          }

          .dh-error-table tbody td {
            padding: 1rem;
            border: none;
            border-bottom: 1px solid #f3f4f6;
            vertical-align: top;
          }

          .dh-error-table tbody tr:hover {
            background-color: #fef2f2;
          }

          .dh-error-table .badge {
            font-size: 0.85rem !important;
            padding: 0.5rem 0.75rem;
          }

          .dh-error-table ul li {
            padding: 0.25rem 0;
            font-size: 0.9rem;
          }
        `}
      </style>
      
      <div className="dh-carga-bg">
        <div className="container-fluid py-4">
          <ToastContainer />
          <div className="dh-card-main">
            <div className="dh-card-header">
              <div className="d-flex justify-content-between align-items-center">
                <h5 className="dh-header-title">Carga Masiva de Trabajadores</h5>
                <div className="btn-group">
                  <button
                    type="button"
                    className="btn-dh-info d-flex align-items-center gap-2"
                    onClick={downloadTemplate}
                    title="Descargar plantilla Excel"
                  >
                    <MdDownload size={20} />
                    Descargar Template
                  </button>
                  <button
                    type="button"
                    className="btn-dh-warning d-flex align-items-center gap-2"
                    onClick={resetForm}
                    disabled={isLoading}
                    title="Limpiar formulario"
                  >
                    <MdRefresh size={20} />
                    Limpiar
                  </button>
                  <button 
                    className="btn-dh-secondary d-flex align-items-center gap-2" 
                    onClick={() => navigate("/home")}
                    title="Volver al inicio"
                  >
                    <MdLogout size={20} />
                    Cerrar
                  </button>
                </div>
              </div>
            </div>

            <div className="card-body" style={{ padding: '2rem' }}>
              <form onSubmit={handleSubmit}>
                <div className="dh-form-container">
                  <div className="row">
                    {/* Selección de Cliente */}
                    <div className="col-md-6 mb-4">
                      <label htmlFor="id_cliente" className="form-label-dh">
                        Cliente <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-select-dh"
                        id="id_cliente"
                        name="id_cliente"
                        value={additionalData.id_cliente || ""}
                        onChange={handleInputChange}
                        required
                        disabled={isLoading}
                      >
                        <option value="">Seleccione un cliente</option>
                        {clientes.map((cliente) => (
                          <option key={cliente.id} value={cliente.id}>
                            {cliente.nombre}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* Fila de opciones avanzadas */}
                  <div className="row">
                    {/* Opción para saltar validación de DNI duplicados */}
                    <div className="col-md-6 mb-3">
                      <div className="form-check" style={{
                        background: 'linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%)',
                        padding: '1rem 1.5rem',
                        borderRadius: '12px',
                        border: '2px solid #f59e0b',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center'
                      }}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="skipDuplicateDniValidation"
                          checked={skipDuplicateDniValidation}
                          onChange={(e) => setSkipDuplicateDniValidation(e.target.checked)}
                          disabled={isLoading}
                          style={{
                            width: '1.5rem',
                            height: '1.5rem',
                            marginTop: '0',
                            cursor: 'pointer',
                            flexShrink: 0
                          }}
                        />
                        <label 
                          className="form-check-label ms-2 mb-0" 
                          htmlFor="skipDuplicateDniValidation"
                          style={{
                            fontWeight: '600',
                            color: '#92400e',
                            cursor: 'pointer',
                            fontSize: '0.95rem'
                          }}
                        >
                          <i className="fas fa-exclamation-triangle me-2"></i>
                          Permitir DNI duplicados en el archivo
                          <small className="d-block mt-1" style={{fontSize: '0.85rem', color: '#78350f'}}>
                            Si se marca, se procesará solo la primera aparición de cada DNI duplicado
                          </small>
                        </label>
                      </div>
                    </div>

                    {/* Opción para autocompletar longitud de documentos */}
                    <div className="col-md-6 mb-3">
                      <div className="form-check" style={{
                        background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
                        padding: '1rem 1.5rem',
                        borderRadius: '12px',
                        border: '2px solid #3b82f6',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center'
                      }}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="autoCompleteDniLength"
                          checked={autoCompleteDniLength}
                          onChange={(e) => setAutoCompleteDniLength(e.target.checked)}
                          disabled={isLoading}
                          style={{
                            width: '1.5rem',
                            height: '1.5rem',
                            marginTop: '0',
                            cursor: 'pointer',
                            flexShrink: 0
                          }}
                        />
                        <label 
                          className="form-check-label ms-2 mb-0" 
                          htmlFor="autoCompleteDniLength"
                          style={{
                            fontWeight: '600',
                            color: '#1e40af',
                            cursor: 'pointer',
                            fontSize: '0.95rem'
                          }}
                        >
                          <i className="fas fa-magic me-2"></i>
                          Autocompletar longitud de documentos
                          <small className="d-block mt-1" style={{fontSize: '0.85rem', color: '#1e3a8a'}}>
                            Completa con ceros a la izquierda según el tipo de documento (DNI: 8 dígitos)
                          </small>
                        </label>
                      </div>
                    </div>

                  </div>
                </div>

                {/* Archivo Excel */}
                <div className="row">
                  <div className="col-12">
                    <label className="form-label-dh">
                      Archivo Excel <span className="text-danger">*</span>
                    </label>
                    
                    {/* Información sobre columnas requeridas */}
                    <div className="alert alert-info mb-3" style={{ 
                      backgroundColor: '#e7f3ff', 
                      border: '1px solid #b3d9ff', 
                      borderRadius: '8px',
                      padding: '1rem'
                    }}>
                      <strong>📋 Formato del archivo Excel:</strong>
                      <p className="mb-2 mt-2">El archivo debe tener las siguientes columnas en este orden exacto:</p>
                      <div className="row">
                        <div className="col-md-6">
                          <ol className="mb-2" style={{ paddingLeft: '1.5rem' }}>
                            <li><strong>ID TRABAJADOR</strong> <span className="text-muted">(opcional)</span></li>
                            <li><strong>DNI</strong> <span className="text-danger">(requerido)</span></li>
                            <li><strong>APELLIDOS Y NOMBRES</strong> <span className="text-danger">(requerido)</span></li>
                            <li><strong>CONTRATO</strong> <span className="text-muted">(opcional)</span></li>
                            <li><strong>GÉNERO</strong> <span className="text-danger">(requerido)</span></li>
                            <li><strong>FECHA INGRESO A PROYECTO</strong> <span className="text-muted">(opcional)</span></li>
                            <li><strong>CATEGORIA CARGO</strong> <span className="text-danger">(requerido)</span></li>
                            <li><strong>CARGO STRACON PERU</strong> <span className="text-muted">(opcional)</span></li>
                            <li><strong>AREA</strong> <span className="text-muted">(opcional)</span></li>
                            <li><strong>REGIMEN</strong> <span className="text-muted">(opcional)</span></li>
                          </ol>
                        </div>
                        <div className="col-md-6">
                          <ol start="11" className="mb-2" style={{ paddingLeft: '1.5rem' }}>
                            <li><strong>TIPO DIRECTO-INDIRECTO</strong> <span className="text-muted">(opcional)</span></li>
                            <li><strong>TIPO MANO DE OBRA</strong> <span className="text-muted">(opcional, ej: MOC)</span></li>
                            <li><strong>CENTRO COSTO</strong> <span className="text-muted">(opcional)</span></li>
                            <li><strong>TELEFONO</strong> <span className="text-muted">(opcional)</span></li>
                            <li><strong>DEPARTAMENTO</strong> <span className="text-muted">(opcional)</span></li>
                            <li><strong>ORIGEN</strong> <span className="text-muted">(opcional: Local/Foráneo)</span></li>
                            <li><strong>LOCALÍA</strong> <span className="text-muted">(opcional)</span></li>
                            <li><strong>ESTADO DEL COLABORADOR</strong> <span className="text-muted">(opcional)</span></li>
                            <li><strong>ESTADO IN SITE</strong> <span className="text-muted">(opcional: In Site/Out Site)</span></li>
                          </ol>
                        </div>
                      </div>
                      <div className="dh-alert-warning mt-3" style={{backgroundColor: '#fff3cd', border: '1px solid #ffc107', borderRadius: '8px', padding: '0.75rem'}}>
                        <small>
                          <strong>Importante:</strong> Los nombres de las columnas deben ser exactos (case-insensitive). 
                          Los valores de tablas maestras (Género, Categoría, Tipo Contrato, etc.) se buscarán usando UPPER para evitar errores de escritura.
                          Use el template para asegurar el formato correcto.
                        </small>
                      </div>
                    </div>
                    
                    <div className={`dh-upload-section ${file ? 'has-file' : ''}`}>
                      <MdCloudUpload size={64} className="upload-icon" />
                      <input
                        type="file"
                        id="excel_file"
                        accept=".xlsx,.xls"
                        onChange={handleFileChange}
                        required
                        disabled={isLoading || file}
                        style={{ display: 'none' }}
                      />
                      {!file ? (
                        <>
                          <div className="upload-text">Seleccione su archivo Excel</div>
                          <div className="upload-subtext">Formatos soportados: .xlsx, .xls</div>
                          <label 
                            htmlFor="excel_file" 
                            className="btn-dh-primary btn-file-uniform" 
                            style={{ cursor: (isLoading || isValidating) ? 'not-allowed' : 'pointer' }}
                          >
                            {isValidating ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Validando...
                              </>
                            ) : (
                              <>
                                <MdUpload size={20} className="me-2" />
                                Examinar Archivos
                              </>
                            )}
                          </label>
                        </>
                      ) : (
                        <>
                          <div className="upload-text">
                            {isFileValid ? "Archivo validado correctamente" : "Archivo seleccionado"}
                          </div>
                          <div className="upload-subtext">
                            <strong>Archivo cargado:</strong>
                          </div>
                          <div className="d-flex flex-column align-items-center">
                            <div className={`file-selected-display ${isFileValid ? '' : 'bg-warning'}`}>
                              <i className={`fas ${isFileValid ? 'fa-check-circle' : 'fa-exclamation-triangle'} me-2`}></i>
                              {file.name}
                            </div>
                            {isFileValid && (
                              <div className="alert alert-success mt-2 mb-0" style={{ padding: '0.5rem 1rem', fontSize: '0.9rem' }}>
                                <i className="fas fa-check-circle me-2"></i>
                                El archivo cumple con todos los requisitos
                              </div>
                            )}
                            <button
                              type="button"
                              className="btn-dh-warning btn-file-uniform"
                              onClick={() => {
                                setFile(null);
                                setFileForRevalidation(null);
                                setResults(null);
                                setFileValidationErrors([]);
                                setIsFileValid(false);
                                setSkipDniValidation(false);
                                setSkipDuplicateDniValidation(false);
                                setAutoCompleteDniLength(false);
                                const fileInput = document.querySelector('input[type="file"]');
                                if (fileInput) {
                                  fileInput.value = '';
                                }
                              }}
                              disabled={isLoading || isValidating}
                            >
                              <i className="fas fa-times me-2"></i>
                              Cambiar Archivo
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {/* Errores de validación del archivo */}
                {fileValidationErrors.length > 0 && (
                  <div className="mt-4">
                    <div className="alert alert-danger">
                      <h6 className="alert-heading fw-bold">
                        <i className="fas fa-exclamation-triangle me-2"></i>
                        Errores de Validación del Archivo Excel
                      </h6>
                      <p className="mb-3">
                        <strong>⚠️ El archivo no puede ser procesado:</strong> Corrija los siguientes errores antes de intentar cargar el archivo.
                      </p>
                      <div className="table-responsive mt-3">
                        <table className="dh-error-table table mb-0">
                          <thead className="table-dark">
                            <tr>
                              <th style={{ width: '100px', backgroundColor: '#343a40', color: '#ffffff' }}>📍 Fila Excel</th>
                              <th style={{ backgroundColor: '#343a40', color: '#ffffff' }}>🚫 Errores de Validación</th>
                            </tr>
                          </thead>
                          <tbody>
                            {fileValidationErrors.map((error, index) => (
                              <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#f8f9fa' : '#ffffff' }}>
                                <td className="fw-bold text-center" style={{ backgroundColor: index % 2 === 0 ? '#f8f9fa' : '#ffffff' }}>
                                  <span className="badge bg-danger fs-6">{error.fila}</span>
                                </td>
                                <td style={{ backgroundColor: index % 2 === 0 ? '#f8f9fa' : '#ffffff' }}>
                                  <ul className="list-unstyled mb-0">
                                    {Array.isArray(error.errores)
                                      ? error.errores.map((err, idx) => (
                                          <li key={idx} className="mb-1" style={{ color: '#dc3545' }}>
                                            <i className="fas fa-times-circle text-danger me-2"></i>
                                            {err}
                                          </li>
                                        ))
                                      : (
                                          <li style={{ color: '#dc3545' }}>
                                            <i className="fas fa-times-circle text-danger me-2"></i>
                                            {error.errores}
                                          </li>
                                        )
                                    }
                                  </ul>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      {/* Botón para saltar validación de DNI si hay errores de DNI */}
                      {fileValidationErrors.some(error => 
                        Array.isArray(error.errores) 
                          ? error.errores.some(err => err.includes('DNI debe tener exactamente 8 caracteres') || err.includes('El DNI debe tener'))
                          : (error.errores && (error.errores.includes('DNI debe tener exactamente 8 caracteres') || error.errores.includes('El DNI debe tener')))
                      ) && (
                        <div className="mt-3 p-3" style={{ 
                          backgroundColor: '#fff3cd', 
                          border: '1px solid #ffc107', 
                          borderRadius: '8px' 
                        }}>
                          <div className="d-flex align-items-center justify-content-between">
                            <div>
                              <strong className="text-warning">
                                <i className="fas fa-exclamation-triangle me-2"></i>
                                Errores de validación de DNI detectados
                              </strong>
                              <p className="mb-0 mt-2 text-muted">
                                Si desea procesar el archivo ignorando la validación de longitud del DNI, 
                                puede hacer clic en el botón a continuación. Los registros se procesarán con los DNIs tal como están en el archivo.
                              </p>
                            </div>
                            <button
                              type="button"
                              className="btn btn-warning ms-3"
                              onClick={async () => {
                                if (!fileForRevalidation) {
                                  showToast("error", "No hay archivo disponible para revalidar. Por favor, seleccione el archivo nuevamente.");
                                  return;
                                }
                                
                                if (!additionalData.id_cliente) {
                                  showToast("error", "Por favor seleccione un cliente antes de revalidar.");
                                  return;
                                }
                                
                                setSkipDniValidation(true);
                                setIsValidating(true);
                                showToast("info", "Validación de DNI deshabilitada. Revalidando archivo...");
                                
                                try {
                                  const validationResponse = await trabajadorApi.validateBulkUploadFile(
                                    fileForRevalidation,
                                    null,
                                    additionalData.id_cliente,
                                    true, // skip_dni_validation = true
                                    skipDuplicateDniValidation,
                                    autoCompleteDniLength
                                  );
                                  
                                  console.log('📋 Respuesta de revalidación:', validationResponse.data);
                                  
                                  if (validationResponse.data && validationResponse.data.success === false) {
                                    const errors = validationResponse.data.errores_detallados || [];
                                    // Filtrar errores de DNI
                                    const errorsFiltered = errors.map(error => ({
                                      ...error,
                                      errores: Array.isArray(error.errores) 
                                        ? error.errores.filter(err => !err.includes('DNI debe tener exactamente 8 caracteres') && !err.includes('El DNI debe tener'))
                                        : (error.errores && !error.errores.includes('DNI debe tener exactamente 8 caracteres') && !error.errores.includes('El DNI debe tener') ? error.errores : [])
                                    })).filter(error => 
                                      (Array.isArray(error.errores) && error.errores.length > 0) || 
                                      (!Array.isArray(error.errores) && error.errores)
                                    );
                                    
                                    if (errorsFiltered.length === 0) {
                                      // No hay más errores, archivo válido
                                      setFile(fileForRevalidation);
                                      setFileValidationErrors([]);
                                      setIsFileValid(true);
                                      showToast("success", `✅ Archivo "${fileForRevalidation.name}" validado correctamente. La validación de DNI ha sido omitida y el archivo está listo para procesar.`);
                                    } else {
                                      setFileValidationErrors(errorsFiltered);
                                      setIsFileValid(false);
                                      showToast("warning", `⚠️ Algunos errores persisten (${errorsFiltered.length} filas con problemas). La validación de DNI ha sido omitida.`);
                                    }
                                  } else {
                                    // Archivo válido
                                    setFile(fileForRevalidation);
                                    setFileValidationErrors([]);
                                    setIsFileValid(true);
                                    showToast("success", `✅ Archivo "${fileForRevalidation.name}" validado correctamente. La validación de DNI ha sido omitida y el archivo está listo para procesar.`);
                                  }
                                } catch (error) {
                                  console.error('❌ Error al revalidar archivo:', error);
                                  const errorMessage = error.response?.data?.message || error.message || "Error al revalidar el archivo";
                                  showToast("error", `Error al revalidar el archivo: ${errorMessage}`);
                                } finally {
                                  setIsValidating(false);
                                }
                              }}
                              disabled={isValidating || !fileForRevalidation || !additionalData.id_cliente}
                            >
                              <i className="fas fa-forward me-2"></i>
                              Saltar Validación de DNI
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* Botón de envío */}
                <button
                  type="submit"
                  className="btn-submit-dh d-flex align-items-center justify-content-center gap-2"
                  disabled={isLoading || isValidating || !file || !isFileValid || !additionalData.id_cliente}
                >
                  {isLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      Procesando archivo...
                    </>
                  ) : isValidating ? (
                    <>
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      Validando archivo...
                    </>
                  ) : (
                    <>
                      <MdUpload size={24} />
                      Cargar Trabajadores
                    </>
                  )}
                </button>
              </form>

              {/* Barra de progreso */}
              {isLoading && (
                <div className="dh-progress-section">
                  <h6 className="fw-bold mb-3 text-center">
                    <i className="fas fa-cog fa-spin me-2"></i>
                    Procesando archivo...
                  </h6>
                  <div className="progress-dh">
                    <div
                      className="progress-bar-dh progress-bar-striped progress-bar-animated"
                      role="progressbar"
                      style={{ width: `${progress}%` }}
                      aria-valuenow={progress}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                  <div className="text-center">
                    <span className="fw-bold">{progress}% completado</span>
                  </div>
                </div>
              )}

              {/* Resultados */}
              {results && (
                <div className="dh-results-card">
                  <div className="dh-results-header">
                    <h5 className="mb-0 fw-bold">
                      <i className="fas fa-chart-bar me-2"></i>
                      Resultados de la Carga
                    </h5>
                  </div>
                  <div className="dh-results-body">
                    {/* Primera fila - Total */}
                    <div className="row mb-3">
                      <div className="col-md-12">
                        <div className="dh-stat-card" style={{backgroundColor: '#f8f9fa', border: '2px solid #dee2e6'}}>
                          <div className="stat-number text-primary" style={{fontSize: '3rem'}}>{results.total}</div>
                          <div className="stat-label" style={{fontSize: '1.1rem', fontWeight: 'bold'}}>TOTAL PROCESADOS</div>
                        </div>
                      </div>
                    </div>
                    
                    {/* Segunda fila - Detalles */}
                    <div className="row">
                      <div className="col-md-3 mb-4">
                        <div className="dh-stat-card">
                          <div className="stat-number text-success">{results.nuevosTrabajadores}</div>
                          <div className="stat-label">Trabajadores Nuevos</div>
                        </div>
                      </div>
                      <div className="col-md-3 mb-4">
                        <div className="dh-stat-card">
                          <div className="stat-number text-info">{results.actualizados}</div>
                          <div className="stat-label">Trabajadores Actualizados</div>
                        </div>
                      </div>
                      <div className="col-md-3 mb-4">
                        <div className="dh-stat-card">
                          <div className="stat-number text-warning">{results.ignored || 0}</div>
                          <div className="stat-label">Filas Ignoradas</div>
                        </div>
                      </div>
                      <div className="col-md-3 mb-4">
                        <div className="dh-stat-card">
                          <div className="stat-number text-danger">{results.errors}</div>
                          <div className="stat-label">Errores</div>
                        </div>
                      </div>
                    </div>

                    {/* Mensaje detallado si todas las filas fueron ignoradas */}
                    {results.mensajeDetallado && (
                      <div className="alert alert-info mt-3">
                        <i className="fas fa-info-circle me-2"></i>
                        {results.mensajeDetallado}
                      </div>
                    )}

                    {/* Botón para descargar filas ignoradas */}
                    {(results.ignoredDetails && results.ignoredDetails.length > 0) && (
                      <div className="mt-4">
                        <div className="alert alert-warning d-flex justify-content-between align-items-center">
                          <div>
                            <h6 className="alert-heading fw-bold mb-2">
                              <i className="fas fa-info-circle me-2"></i>
                              Filas Ignoradas ({results.ignoredDetails.length})
                            </h6>
                            <p className="mb-0">
                              Se ignoraron {results.ignoredDetails.length} filas porque los DNI ya existen en la base de datos o son duplicados dentro del archivo.
                            </p>
                          </div>
                          <button
                            type="button"
                            className="btn btn-success d-flex align-items-center gap-2"
                            onClick={downloadIgnoredRows}
                            style={{
                              minWidth: '200px',
                              padding: '12px 20px',
                              fontWeight: '600',
                              borderRadius: '8px'
                            }}
                          >
                            <i className="fas fa-file-excel" style={{fontSize: '1.2rem'}}></i>
                            Descargar Excel
                          </button>
                        </div>
                      </div>
                    )}

                    {/* Detalles de errores */}
                    {(results.details && results.details.length > 0) && (
                      <div className="mt-4">
                        <div className="alert alert-danger">
                          <h6 className="alert-heading fw-bold">
                            <i className="fas fa-exclamation-triangle me-2"></i>
                            Errores de Validación Encontrados ({results.details.length} filas con problemas)
                          </h6>
                          <p className="mb-3">
                            <strong>⚠️ Carga Cancelada:</strong> Corrija los siguientes errores en el archivo Excel y vuelva a intentar la carga.
                          </p>
                          <div className="table-responsive mt-3">
                            <table className="dh-error-table table mb-0">
                              <thead className="table-dark">
                                <tr>
                                  <th style={{ width: '100px', backgroundColor: '#343a40', color: '#ffffff' }}>📍 Fila Excel</th>
                                  <th style={{ backgroundColor: '#343a40', color: '#ffffff' }}>🚫 Errores de Validación</th>
                                </tr>
                              </thead>
                              <tbody>
                                {results.details.map((error, index) => (
                                  <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#f8f9fa' : '#ffffff' }}>
                                    <td className="fw-bold text-center" style={{ backgroundColor: index % 2 === 0 ? '#f8f9fa' : '#ffffff' }}>
                                      <span className="badge bg-danger fs-6">{error.fila}</span>
                                    </td>
                                    <td style={{ backgroundColor: index % 2 === 0 ? '#f8f9fa' : '#ffffff' }}>
                                      <ul className="list-unstyled mb-0">
                                        {Array.isArray(error.errores)
                                          ? error.errores.map((err, idx) => (
                                              <li key={idx} className="mb-1" style={{ color: '#dc3545' }}>
                                                <i className="fas fa-times-circle text-danger me-2"></i>
                                                {err}
                                              </li>
                                            ))
                                          : (
                                              <li style={{ color: '#dc3545' }}>
                                                <i className="fas fa-times-circle text-danger me-2"></i>
                                                {error.errores}
                                              </li>
                                            )
                                        }
                                      </ul>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                            {results.details.length > 10 && (
                              <div className="text-center mt-2">
                                <small className="text-muted">
                                  ... y {results.details.length - 10} errores más
                                </small>
                              </div>
                            )}
                          </div>
                          {/* Botón para saltar validación de DNI si hay errores de DNI en resultados */}
                          {results.details && results.details.some(error => 
                            Array.isArray(error.errores) 
                              ? error.errores.some(err => err.includes('DNI debe tener exactamente 8 caracteres') || err.includes('El DNI debe tener'))
                              : (error.errores && (error.errores.includes('DNI debe tener exactamente 8 caracteres') || error.errores.includes('El DNI debe tener')))
                          ) && (
                            <div className="mt-3 p-3" style={{ 
                              backgroundColor: '#fff3cd', 
                              border: '1px solid #ffc107', 
                              borderRadius: '8px' 
                            }}>
                              <div className="d-flex align-items-center justify-content-between">
                                <div>
                                  <strong className="text-warning">
                                    <i className="fas fa-exclamation-triangle me-2"></i>
                                    Errores de validación de DNI detectados
                                  </strong>
                                  <p className="mb-0 mt-2 text-muted">
                                    Si desea procesar el archivo ignorando la validación de longitud del DNI, 
                                    puede hacer clic en el botón a continuación y volver a cargar el archivo.
                                  </p>
                                </div>
                                <button
                                  type="button"
                                  className="btn btn-warning ms-3"
                                  onClick={() => {
                                    setSkipDniValidation(true);
                                    showToast("info", "Validación de DNI deshabilitada. Puede volver a cargar el archivo.");
                                  }}
                                >
                                  <i className="fas fa-forward me-2"></i>
                                  Saltar Validación de DNI y Reintentar
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                    
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CargaMasivaTrabajadores;
